import type { Theme } from '@mui/material/styles';
import { getPanelDividerBg } from '../../../theme/uiSemanticColors';

export const panelDividerBg = (theme: Pick<Theme, 'palette'> & { palette: Theme['palette'] }): string =>
  getPanelDividerBg(theme as Theme);
